export default (seconds, callback) => setTimeout(callback, seconds * 1000);
